export default __webpack_public_path__ + "static/media/photo--sm--kickoff6.9f8b9c77.jpg";